import { type FormHTMLAttributes, type ReactNode } from "react";
import { cx } from "class-variance-authority";

import * as styles from "./Form.module.scss";

type FormProps = FormHTMLAttributes<HTMLFormElement> & {
  children: ReactNode;
  noSpacing?: boolean;
  withGap?: boolean;
  className?: string;
  fixedWidth?: boolean;
  disabled?: boolean;
};

const Form = ({
  children,
  noSpacing = false,
  withGap = false,
  fixedWidth = false,
  disabled,
  className,
  ...rest
}: FormProps) => {
  return (
    <form
      className={cx(
        styles.form,
        {
          [styles.noSpacing]: noSpacing,
          [styles.withGap]: withGap,
          [styles.fixedWidth]: fixedWidth,
        },
        className,
      )}
      {...rest}
    >
      <fieldset className={styles.fieldset} disabled={!!disabled}>
        {children}
      </fieldset>
    </form>
  );
};

Form.displayName = "Form";

export { Form };
